const dashboardViewModes = ["card", "list", "expanded", "full"];

function normalizeDashboardViewMode(raw) {
  const value = String(raw || "").trim().toLowerCase();
  return dashboardViewModes.indexOf(value) >= 0 ? value : "card";
}

function submitForm(form) {
  if (!(form instanceof HTMLFormElement)) {
    return;
  }

  if (typeof form.requestSubmit === "function") {
    form.requestSubmit();
    return;
  }

  form.submit();
}

export function setDashboardViewMode(mode) {
  const normalizedMode = normalizeDashboardViewMode(mode);
  const modeInput = document.querySelector("form[action='/dashboard/view'] input[name='mode'][value='" + normalizedMode + "']");
  if (!(modeInput instanceof HTMLInputElement)) {
    return false;
  }

  const form = modeInput.closest("form");
  if (!(form instanceof HTMLFormElement)) {
    return false;
  }

  submitForm(form);
  return true;
}

export function initDashboardViewControls() {
  document.addEventListener("click", function (event) {
    const trigger = event.target instanceof Element
      ? event.target.closest("[data-dashboard-view-button]")
      : null;
    if (!(trigger instanceof HTMLElement)) {
      return;
    }

    const mode = trigger.getAttribute("data-dashboard-view-button");
    if (!mode) {
      return;
    }

    if (setDashboardViewMode(mode)) {
      event.preventDefault();
    }
  });
}
